export const formatTime = (sec: number) => {
  const pad = (num: number) => (num >= 10 ? num.toString() : `0${num}`);
  const mm = pad(Math.floor(sec / 60));
  const ss = pad(sec % 60);

  return `${mm}:${ss}`;
};

export const differenceIsLessThan = (pastTime: number, maxDifference: number): boolean => {
  return pastTime + maxDifference >= Date.now();
};
